module.exports = __webpack_public_path__ + "img/zendesk-logo.78dbf790.svg";